import { render, staticRenderFns } from "./PosInvoicesCloseSummary.vue?vue&type=template&id=990f0ef6&scoped=true&"
import script from "./PosInvoicesCloseSummary.vue?vue&type=script&lang=js&"
export * from "./PosInvoicesCloseSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990f0ef6",
  null
  
)

export default component.exports